var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mb-5 lg:hidden"},[_c('a',{staticClass:"cursor-pointer flex items-center",on:{"click":_vm.back}},[_c('img',{staticClass:"mr-2",attrs:{"loading":"lazy","src":"/img/icons/left-arrow.svg"}}),_vm._v(" "),_c('span',{staticClass:"go-back-link font-bold"},[_vm._v(_vm._s(_vm.trans.get('customer.go-back')))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }